import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import Funding from './section-components/funding';
import Footer from './global-components/footer';

const SignInPage = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Invested Projects"  />
        <Funding />
        <Footer />
    </div>
}

export default SignInPage

